import React, { Component } from 'react';
import { Grid, Segment, Header } from 'semantic-ui-react';
import QueryString from 'query-string';

import Conversation from '../../component/chat/conversation';

class AskJoeyPage extends Component {
    render() {
        const parsedQueryString = QueryString.parse(this.props.location.search);
        return (
            <Grid columns={4}>
                <Grid.Row>
                    <Grid.Column width={16}>
                        <Header as='h4' attached='top' block>
                            Ask Joey
                        </Header>
                        <Segment attached>
                            <Grid>
                                <Conversation history={this.props.history} queryString={parsedQueryString}/>
                            </Grid>
                        </Segment>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

export default AskJoeyPage;

/*

<List.Item>
<List.Content floated='right'>
    <Button>View</Button>
</List.Content>
<Image avatar src='https://react.semantic-ui.com/images/avatar/small/lindsay.png' />
<List.Content>Lindsay</List.Content>
</List.Item>
<List.Item>
<List.Content floated='right'>
    <Button>View</Button>
</List.Content>
<Image avatar src='https://react.semantic-ui.com/images/avatar/small/mark.png' />
<List.Content>Mark</List.Content>
</List.Item>
<List.Item>
<List.Content floated='right'>
    <Button>View</Button>
</List.Content>
<Image avatar src='https://react.semantic-ui.com/images/avatar/small/molly.png' />
<List.Content>Molly</List.Content>
</List.Item>

*/